export const HUB_REQUEST = "HUB_REQUEST";
export const HUB_RECEIVE = "HUB_RECEIVE";
export const HUB_FAILURE = "HUB_FAILURE";
export const RESET_HUB = "RESET_HUB";
